import mergeClasses from "utils/mergeClasses";

export default function useMergeClasses<T, K>(classes1: T, classes2?: K) {
  return mergeClasses(classes1, classes2);
}
